<script>
// import axios from "axios";
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
//import tableCards from "@/components/widgets/tableCards";
import axios from "axios";
import { todoMethods, todoComputed } from "@/state/helpers";
import Fields from "@/helpers/fields";
import { tableData } from "../dataAdvancedtable";
import Vue from "vue";
import VueAxios from "vue-axios";
import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

Vue.use(VueAxios, axios);

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Tarjetas",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    //tableCards,
  },
  data() {
    return {
      // ************************************** Link
      tableData: tableData,
      title: "Tarjetas",
      items: [
        {
          text: "Escritorio",
          href: "/",
        },
        {
          text: "Tarjetas",
          active: true,
        },
      ],
      tableCards: [],
      showModal: false,
      isLoading: false,
      fullPage: true,
      canCancel: false,
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      todocurrentPage: 1,
      perPage: 10,
      todoperPage: 10,
      pageOptions: [10, 25, 50, 100],
      todoOptions: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortBy: "age",
      sortDesc: false,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#FFFFFF",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,
      cardFields: Fields.cardFields,
      isShow:false,
      folio:""
    };
  },

  computed: {
    ...todoComputed,
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },

    /**
     * Todo list of records
     */
    todoList() {
      return this.todos.length;
    },
    isCapturista() {
      const {permit} = JSON.parse(localStorage.getItem('permits'));
      // console.log(permit);
      if (permit === 'capturista' || permit === 'admin') {
        return true;
      }else{
        return false;
      }
    }
  },

  mounted() {
    // this.getTable();

    this.fetchTodos();
    // Set the initial number of items
    this.totalRows = this.tableData.length;

    this.todoTotalRows = this.todos.length;

    // Set the class table-light to the thead element
    document.getElementById("b_table_card").firstElementChild.classList.add("table-light");
  },

  methods: {
    ...todoMethods,

    getTable() {
      this.isLoading = true;
      axios.get("http://ec2-18-237-53-89.us-west-2.compute.amazonaws.com:3010/app/tarjetas").then((response) => {
        this.isLoading = false;
        this.response = response.data.data;
        this.tableCards = response.data.data;
        //console.log(response);
      });
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    todoFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.todoTotalRows = filteredItems.length;
      this.todocurrentPage = 1;
    },

    getColor(estado) {
      if (estado == "Activo") return "red";
      else return "green";
    },

    handleInput(value, data) {
      this.editableDataItems[data.index][data.field.key] = value;
    },

    handleEdit(id_tarjeta) {
      this.$router.push({
        name: "ActualizaTarjetas",
        params: {
          id_tarjeta: id_tarjeta,
        },
      });
    },

    handleDelete(id_tarjeta) {
      console.log(id_tarjeta);
      this.$swal({
        title: "¿Estas seguro de borrar?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, borrar",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          axios.put("/tarjetas",{ id_tarjeta: id_tarjeta, estatus: "0" })
          .then((res) => {
            const { response = "" } = res.data;
            if (response === true) {
              this.$swal(
                "Eliminado!",
                "La Tarjeta ha sido borrado con exito.",
                "success"
              );
              this.tableCards = [];
              // this.getTable();
            } else {
              this.$swal("Alerta!", "No se pudo eliminar", "warning");
            }
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.log(error);
            this.$swal("Error!", "Ocurrio un error", "danger");
          });
        }
      });
    },
    handleSearch(){
      this.isShow = false;
      const folio = this.folio;
      axios.get(`/tarjetaBuscar?folio=${folio}`)
      .then((res) => {
        const { response = "", data={}} = res.data;
        if (response === true) {
          console.log(data);
          this.tableCards = [res.data.data];
          this.isShow = true;
        } else {
          console.log('aqui');
          this.tableCards = [];
          this.isShow = true;
        }
      })
      .catch((error) => {
        console.log(error);
        this.tableCards = [];
          this.isShow = true;
      });
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <v-row class="mb-6">
      <v-col md="12">
        <v-card>
          <div class="card-body">
            <v-row>
              <v-col md="6">
                <h4 class="card-title mb-4">Buscador de Tarjetas</h4>
              </v-col>
              <!-- <v-col md="6 text-md-end" v-if="isCapturista">
                <router-link to="/NuevaTarjeta">
                  <v-btn
                    depressed
                    color="primary"
                    type="button"
                    id="button-addon2"
                  >
                    Nuevo registro
                  </v-btn>
                </router-link>
                <v-divider class="mx-2" inset vertical></v-divider>
                <router-link to="/RegistroMasivo">
                  <v-btn color="success" id="button-addon2">
                    Registro Masivo
                  </v-btn>
                </router-link>
              </v-col> -->
            </v-row>
            <v-row>
              <v-col md="6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Ver
                    <v-divider class="mx-1" inset vertical></v-divider>
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                    <v-divider class="mx-1" inset vertical></v-divider>
                    registros
                  </label>
                </div>
              </v-col>
              <!-- Search -->
              <!-- <v-col md="6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Buscar:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Buscar..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </v-col> -->
              <!-- End search -->
            </v-row>
            <div class="d-flex justify-content-center align-items-center h-50" v-if="isLoading == true">
              <b-spinner variant="primary"></b-spinner>
            </div>
            <v-row>
              <v-col md="8">
                <b> <label class="form-check-label">Folio</label> </b>
                <div class="mb-4">
                  <b-form-input
                    v-model="folio"
                    id="folio"
                    placeholder="0000000099"
                  ></b-form-input>
                </div>
              </v-col>
              <v-col md="4">
                <v-btn
                  color="primary"
                  type="button"
                  style="margin-top: 15px;"
                  @click="handleSearch()"
                >
                  Buscar
                </v-btn> 
              </v-col>
            </v-row>
            <!-- tableCards table -->
            <b-table
              id="b_table_card"
              :fields="cardFields"
              :items="tableCards"
              :filter="filter"
              :current-page="currentPage"
              :per-page="perPage"
              v-if="isShow"
            >
              <template #cell(id_tarjeta)="data">
                <a href="javascript: void(0);" class="text-body fw-bold">
                  {{ data.item.id_tarjeta }}
                </a>
              </template>
              <template #cell(estatus_entrega)="data">
                <span
                  class="badge badge-pill bg-success font-size-11"
                  :class="{
                    'bg-warning': `${data.item.estatus_entrega}` === '0',
                    'bg-success': `${data.item.estatus_entrega}` === '1',
                  }"
                >
                  {{
                    data.item.estatus_entrega === 1 ? "Entregada" : "No entregada"
                  }}
                </span>
              </template>
              <template #cell(estatus)="data">
                <span
                  class="badge badge-pill bg-success font-size-11"
                  :class="{
                    'bg-danger': `${data.item.estatus}` === '0',
                    'bg-success': `${data.item.estatus}` === '1',
                    'bg-warning': `${data.item.estatus}` === '2',
                  }"
                  >{{
                    data.item.estatus == 0
                      ? "Desactivada"
                      : data.item.estatus === 1
                      ? "Activada"
                      : "Perdida"
                  }}</span
                >
              </template>
              <template #cell(edit)="data">
                <v-btn
                  icon
                  small
                  @click="handleEdit(data.item.id_tarjeta)"
                >
                  <i style="color: #09a5c7" class="bx bxs-pencil"></i>
                </v-btn>
                <v-btn
                  icon
                  small
                  @click="handleDelete(data.item.id_tarjeta)"
                >
                  <i style="color: #e73484" class="bx bx-trash"></i>
                </v-btn>
              </template>
            </b-table>
          </div>
          <v-row class="px-6" v-if="isShow">
            <v-col md="6">
              <span>
                Mostrando {{ perPage > this.tableCards.length ? this.tableCards.length : perPage }} de {{ this.tableCards.length }} registros
              </span>
            </v-col>
            <v-col md="6 text-md-end">
              <b-pagination
                align="right"
                v-model="currentPage"
                :total-rows="this.tableCards.length"
                :per-page="perPage"
                first-text="Primera"
                prev-text="Anterior"
                next-text="Siguiente"
                last-text="Última"
              >
              </b-pagination>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <!-- end col -->
    </v-row>
    <!-- end row -->
  </Layout>
</template>
